import {
    TransactionItemSideStyled,
    TransactionsInfoAmountStyled,
    TransactionsInfoBoxStyled,
    TransactionsInfoDateStyled,
    TransactionsInfoIdStyled,
    TransactionsInfoPaymentLogoStyled,
    TransactionsInfoStatusIconStyled,
    TransactionsInfoStatusStyled,
    TransactionsInfoStatusTextStyled,
    TransactionsInfoStyled
} from "../../../Cashier/styled/CashierStyled";
import moment from "moment";
import amountFormat from "../../../../utils/amountFormat.js";
import { BinIcon } from "../../../../components/icon/Icon.jsx";
import { Button } from "react-bootstrap";
import { useCallback, useMemo } from "react";
import {getTransactionTypeDescriptionText} from "./transactionHistoryUtils";
import classNames from "classnames";
import { STATE_TX, STATUS_TX } from "./transactionHistoryConstants";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { makeSelectPayments } from "../../accountSelectors.js";
import {useGTMEvent} from "../../../GoogleTagManager/googleTagManagerHooks";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext.js";

function TransactionsInfo(props) {
    const {getLangPath} = useLangContext();
    const {
        payments,
        stateToIcon,
        transactionSelected,
    } = props;
    const {handleGTMClick} = useGTMEvent({module: 'Cashier'});

    const handleCopyToClipboardTransactionID = useCallback(() => {
        navigator.clipboard.writeText(transactionSelected.uuid).then();
        handleGTMClick({
            button: 'copy transaction id',
            amount: transactionSelected.amount,
            provider: transactionSelected.payment_name,
            side: transactionSelected.side,
            status: transactionSelected.status,
            state: transactionSelected.state,
            transaction_id: transactionSelected.uuid,
            type: transactionSelected.type,
        });
    }, [transactionSelected, handleGTMClick]);

    const transactionStatusClassName = useMemo(() => classNames({
        success: transactionSelected.state === STATE_TX.COMPLETED,
        error: [STATE_TX.ERROR, STATE_TX.REJECTED].includes(transactionSelected.state),
    }), [transactionSelected.state]);

    const handleCompleteTransaction = useCallback(() => {
        window.open(transactionSelected.payment_url);
    }, [transactionSelected]);

    return <TransactionsInfoStyled>
        <TransactionsInfoBoxStyled>
            {
                !!payments[transactionSelected.payment_id]?.logo ? <>
                        <TransactionsInfoPaymentLogoStyled>
                            <img
                                src={`data:${payments[transactionSelected.payment_id].logo_format},${payments[transactionSelected.payment_id].logo}`}
                                alt={payments[transactionSelected.payment_id].label}/>
                        </TransactionsInfoPaymentLogoStyled>
                        <p>{payments[transactionSelected.payment_id].label}</p>
                    </>
                    : <h6>{transactionSelected.payment_name}</h6>
            }
            <TransactionItemSideStyled>
                {getTransactionTypeDescriptionText({...transactionSelected, getLangPath})}
            </TransactionItemSideStyled>
            <TransactionsInfoDateStyled>{moment(transactionSelected.created_at).format('HH:mm, DD MMM')}</TransactionsInfoDateStyled>
            <TransactionsInfoAmountStyled>{transactionSelected.side === 'up' ?
                '+' :
                '-'}${amountFormat(transactionSelected.amount)}</TransactionsInfoAmountStyled>
            <TransactionsInfoStatusStyled className={transactionStatusClassName}>
                <div className="d-flex">
                    <TransactionsInfoStatusIconStyled>
                        <BinIcon
                            name={stateToIcon[transactionSelected.state]?.iconName}
                            style={{fill: stateToIcon[transactionSelected.state]?.iconColor}}
                        />
                    </TransactionsInfoStatusIconStyled>
                    <TransactionsInfoStatusTextStyled className={transactionStatusClassName}>
                        <h6>{getLangPath(`transactions.state.${transactionSelected.state}.name`)}</h6>
                        <span>{getLangPath(`transactions.state.${transactionSelected.state}.descr`)}</span>
                    </TransactionsInfoStatusTextStyled>
                </div>
                {transactionSelected.status === STATUS_TX.DEPOSIT_CREATED && !!transactionSelected.payment_url && (
                    <div className="d-flex flex-column mt-2">
                        <Button
                            onClick={handleCompleteTransaction}
                            variant="info"
                            size="md"
                            className="f16"
                        >
                            {getLangPath('transactions.complete')}
                        </Button>
                    </div>
                )}
            </TransactionsInfoStatusStyled>
        </TransactionsInfoBoxStyled>
        <TransactionsInfoIdStyled>
            <Button
                onClick={handleCopyToClipboardTransactionID}
                variant="info"
                size="md"
            >
                {getLangPath('transaction_history.copy_transaction_id')}
                <BinIcon name="IcDocCopy" style={{fontSize: '16px', marginLeft: '6px'}}/>
            </Button>
        </TransactionsInfoIdStyled>
    </TransactionsInfoStyled>
}

const mapStateToProps = createStructuredSelector({
    payments: makeSelectPayments(),
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(TransactionsInfo);
